import { CheckCircle, XCircle, HelpCircle } from 'lucide-react';

export const AGE_CATEGORIES = [
  { value: 'beginner', label: 'Beginner' },
  { value: 'u10', label: 'U10' },
  { value: 'u11', label: 'U11' },
  { value: 'u12', label: 'U12' },
  { value: 'u13', label: 'U13' },
  { value: 'u14', label: 'U14' },
  { value: 'u15', label: 'U15' },
  { value: 'u16', label: 'U16' },
  { value: 'u17', label: 'U17' },
  { value: 'u18', label: 'U18' },
  { value: 'u19', label: 'U19' },
];

export const TOURNAMENT_STYLES = [
  { value: 'competition', label: 'Competition', description: 'Competitive play (travel = no divisions, local = Div A/B)' },
  { value: 'recreational', label: 'Recreational', description: 'Fun, recreational play - Div B consideration for local' },
  { value: 'league', label: 'League', description: 'Summer/Fall leagues - no divisions' },
];

export const EXPENSE_CATEGORIES = [
  { value: 'coach_travel', label: 'Coach Travel' },
  { value: 'coach_logistics', label: 'Coach Logistics' },
  { value: 'coach_hours', label: 'Coach Hours' },
  { value: 'coach_game_fee', label: 'Coach Game Fee' },
  { value: 'coach_meals', label: 'Coach Meals' },
  { value: 'tournament_registration', label: 'Tournament Registration' },
  { value: 'other', label: 'Other' },
];

export const DIVISION_PREFERENCES = [
  { value: 'div_a', label: 'Division A (Competitive)', description: 'For players seeking competitive play' },
  { value: 'div_b', label: 'Division B (Recreational)', description: 'For players seeking fun, recreational play' },
];

export const RSVP_OPTIONS = [
  { value: 'yes', label: 'Yes', icon: CheckCircle, color: 'text-green-600', bgColor: 'bg-green-100' },
  { value: 'no', label: 'No', icon: XCircle, color: 'text-red-600', bgColor: 'bg-red-100' },
  { value: 'tentative', label: 'Tentative', icon: HelpCircle, color: 'text-yellow-600', bgColor: 'bg-yellow-100' },
];

export const RSVP_COLORS = {
  yes: 'bg-green-100 text-green-700 border-green-200',
  no: 'bg-red-100 text-red-700 border-red-200',
  tentative: 'bg-yellow-100 text-yellow-700 border-yellow-200',
};

export const statusColors = {
  future: 'bg-blue-100 text-blue-700',
  active: 'bg-green-100 text-green-700',
  closed: 'bg-yellow-100 text-yellow-700',
  past: 'bg-gray-100 text-gray-700',
};

export const registrationStatusColors = {
  pending: 'bg-yellow-100 text-yellow-700',
  selected: 'bg-blue-100 text-blue-700',
  payment_pending: 'bg-orange-100 text-orange-700',
  confirmed: 'bg-green-100 text-green-700',
  not_selected: 'bg-gray-100 text-gray-700',
  cancelled: 'bg-red-100 text-red-700',
};
